import React from "react";
import { Outlet } from "react-router-dom";
import Page404 from "../../views/user/Auth/Page404";

const HodRoute = ({ children }) => {
    const profile = JSON.parse(localStorage.getItem("cred")).profile;
    if (profile.isHod || profile.isReportingHead) {
        return children ? children : <Outlet />;
    } else {
        return (
            <Page404
                message={
                    "Sorry!! You don'nt have the permission for such an action"
                }
            />
        );
    }
};

export default HodRoute;
